<template>
  <div :class="{ 'overview-container--loading': !policy }" class="overview-container">
    <LoadingCard v-if="!policy"></LoadingCard>
    <DynamicPolicyTile v-else :policy="policy" :isDetailHeader="true"></DynamicPolicyTile>
  </div>
</template>

<script setup lang="ts">
import DynamicPolicyTile from '@/components/policy/DynamicPolicyTile.vue'
import LoadingCard from '@/components/common/LoadingCard.vue'
import { onMounted, type Ref, ref } from 'vue'
import type { Policy } from 'policies-api'
import { usePoliciesStore } from '@/stores/policiesStore'

const policy: Ref<Policy | null> = ref(null)

const props = defineProps({
  policyId: {
    type: String,
    required: true
  }
})
onMounted(async () => {
  policy.value = await usePoliciesStore().getPolicyByPolicyId(props.policyId)
})
</script>

<style scoped lang="scss">
.overview-container {
  position: relative;
  overflow: auto;
  &--loading {
    margin-bottom: calc(var(--baseline) * 2);
  }
}
</style>
